import PaletteContent from "@/components/PaletteContent";
import HtmlSnippet from "@/components/HtmlSnippet";
import { useQuery } from "@apollo/client/react";
import { useCallback, useRef, useEffect, useState, cloneElement } from "react";
// schema = {
//  id: id,
//  type: "palette" or "html_snippet",
//  header: {text: "", link: {href: ""}
//  graphql: {query: "graphql query", variables: {variables}, path: ""}
//  viewType: "slider" or "grid" or "list" or "pickuplist" or "carousel"
// }
function PseudoCanvasStructure({ schema, onRendered }) {
  const { type, id } = schema;
  return (
    <>
      {type === "palette" && (
        <PseudoPalette {...schema} onRendered={onRendered} />
      )}
      {type === "html_snippet" && <HtmlSnippet id={id} />}
    </>
  );
}

function PseudoPalette({ id, graphql, onRendered, ...props }) {
  const { query, options, path } = graphql;
  const { data, ...result } = useQuery(query, options);
  const items = data?.[path];

  useEffect(() => {
    if (items && items?.pageInfo) {
      onRendered(id, items.pageInfo.totalCount > 0);
    }
  }, [items, onRendered]);

  return <PaletteContent items={items} {...props} {...result} />;
}

export default function PseudoCanvas({ schemas, noContent }) {
  const schemaResults = useRef();
  const [noResult, setNoResult] = useState(false);

  const handleRenderd = useCallback(
    (key, value) => {
      if (
        schemaResults.current &&
        Object.keys(schemaResults.current).includes(key)
      ) {
        schemaResults.current[key] = value;
        const values = Object.values(schemaResults.current);
        if (values.every((v) => v === false)) {
          setNoResult(true);
        } else {
          setNoResult(false);
        }
      }
    },
    [schemaResults]
  );

  useEffect(() => {
    const entries = schemas.map((schema) => [schema.id, null]);
    schemaResults.current = Object.fromEntries(entries);
    setNoResult(false);
  }, [schemas]);

  return (
    <>
      {schemas.map((schema) => (
        <PseudoCanvasStructure
          key={`pseudo-${schema.id}`}
          schema={schema}
          onRendered={handleRenderd}
        />
      ))}
      {noResult && noContent && cloneElement(noContent)}
    </>
  );
}
